import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '91n官方入口',
    url: 'https://91n.com/',
    description: '91n是您值得信赖的内容平台，提供91n最新入口、91n官方地址及91n使用指南。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://91n.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryGrid />
        <FAQSection />
      </main>
    </>
  );
}